import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import English translations
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enProject from './locales/en/project.json';
import enLanding from './locales/en/landing.json';
import enSettings from './locales/en/settings.json';
import enDetails from './locales/en/details.json';

// Import German translations
import deCommon from './locales/de/common.json';
import deAuth from './locales/de/auth.json';
import deDashboard from './locales/de/dashboard.json';
import deProject from './locales/de/project.json';
import deLanding from './locales/de/landing.json';
import deSettings from './locales/de/settings.json';
import deDetails from './locales/de/details.json';

// Import French translations
import frCommon from './locales/fr/common.json';
import frAuth from './locales/fr/auth.json';
import frDashboard from './locales/fr/dashboard.json';
import frProject from './locales/fr/project.json';
import frLanding from './locales/fr/landing.json';
import frSettings from './locales/fr/settings.json';
import frDetails from './locales/fr/details.json';

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    project: enProject,
    landing: enLanding,
    settings: enSettings,
    details: enDetails,
  },
  de: {
    common: deCommon,
    auth: deAuth,
    dashboard: deDashboard,
    project: deProject,
    landing: deLanding,
    settings: deSettings,
    details: deDetails,
  },
  fr: {
    common: frCommon,
    auth: frAuth,
    dashboard: frDashboard,
    project: frProject,
    landing: frLanding,
    settings: frSettings,
    details: frDetails,
  },
};

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    fallbackLng: 'en', // Fallback to English if translation missing
    defaultNS: 'common', // Default namespace
    ns: ['common', 'auth', 'dashboard', 'project', 'landing', 'settings', 'details'],

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      // Order of language detection
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'], // Save language selection to localStorage
      lookupLocalStorage: 'i18nextLng',
    },

    react: {
      useSuspense: false, // Disable suspense for now
    },
  });

export default i18n;
